"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var heroBaseTheme = function (_a) {
    var _b;
    var MAX_M = _a.MAX_M;
    return ({
        hero: (_b = {
                width: "100%",
                height: "160px",
                backgroundRepeat: "no-repeat",
                backgroundSize: "cover"
            },
            _b[MAX_M] = {
                justifyContent: "flex-end"
            },
            _b),
        heroNavContainer: {},
        heroNavPopover: {
            padding: "0",
            display: "none"
        },
        heroTitleWrapper: {},
        heroTitle: {
            variant: 'h1',
            message: "message.hero.title"
        },
        heroSubTitle: {
            variant: 'h2',
            message: "message.hero.sub-title"
        },
        heroButton: {
            fontSize: "1.5rem",
            fontWeight: "normal",
            height: "3rem",
            padding: '1rem',
            "& p": {
                fontSize: "1.5rem",
            }
        },
        heroSearchBox: {
            icon: 'search',
        },
    });
};
exports.default = heroBaseTheme;
//# sourceMappingURL=hero.js.map